import { render, staticRenderFns } from "./edit-driver-form.vue?vue&type=template&id=b7594e4c&scoped=true&"
import script from "./edit-driver-form.vue?vue&type=script&lang=js&"
export * from "./edit-driver-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7594e4c",
  null
  
)

export default component.exports